import { AxiosErrorHandler, Loading } from 'ui';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Break circular dependency
import { ContentObjectTextContent } from 'features/feed/content-object-text-content';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Break circular dependency
import { usePublicPostQuery } from 'features/feed/queries';

type P = {
  id: string;
};

const PublicPost = ({ id }: P) => {
  const { data: postContentObject, error, isPending } = usePublicPostQuery(id);

  if (isPending) {
    return <Loading />;
  }

  return (
    <AxiosErrorHandler actions={false} error={error}>
      {postContentObject ? (
        <ContentObjectTextContent
          contentId={postContentObject.post.id}
          htmlContent={postContentObject.post.htmlContent}
          itemType={postContentObject.type}
          textContent={postContentObject.post.textContent}
          title={postContentObject.post.title}
        />
      ) : null}
    </AxiosErrorHandler>
  );
};

export default PublicPost;
